export const getUsuarioId = () => {
  const user = JSON.parse(localStorage.user)
  return user.id
}

export const getUsuarioNome = () => {
  const user = JSON.parse(localStorage.user)
  return user.name
}

export const getEmpresaId = () => {
  const empresa = JSON.parse(localStorage.empresa)
  return empresa
}

export const getUsuarioRealm = () => {
  return localStorage.user ? JSON.parse(localStorage.user).realm : null
}

export const deepCopyFunction = inObject => {
  let value, key
  if (typeof inObject !== 'object' || inObject === null) {
    return inObject
  }
  const outObject = Array.isArray(inObject) ? [] : {}
  for (key in inObject) {
    value = inObject[key]
    outObject[key] = deepCopyFunction(value)
  }
  return outObject
}

export const getOnlyDigits = string => {
  return string ? string.replace(/[^\d]/g, '') : ''
}

export const getAlphanumericDigits = string => {
  return string ? string.replace(/\W/g, '') : ''
}

export const formatToPercentage = number =>
  Number(number).toLocaleString('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2
  })

export const normalizeAndEqualizeString = string => {
  return string
    ? string
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
    : ''
}

export const isJson = item => {
  let value = typeof item !== 'string' ? JSON.stringify(item) : item
  try {
    value = JSON.parse(value)
  } catch (e) {
    return false
  }
  return typeof value === 'object' && value !== null
}
